/**
 * Locale key for a platform alert banner. A free WhatsApp number gets its own copy so the banner
 * can say "WhatsApp Free"; an older backend sends no `meta.tier` and keeps the generic line.
 */
export const platformAlertKey = (alert) => {
  if (alert.code === 'WHATSAPP_DISCONNECTED' && alert.meta?.tier === 'FREE') {
    return `platformAlerts.${alert.code}.FREE_${alert.scope}`;
  }
  return `platformAlerts.${alert.code}.${alert.scope}`;
};

export default platformAlertKey;
